import { Button, Col, Form, Input, Layout, Row, Typography } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import signinLogo from "../../assets/images/logo-for-logins.png"; // Changed to match your other pages
import apiPath from "../../constants/apiPath";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";

const { Content } = Layout;
const { Title, Text } = Typography;

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { request } = useRequest();

  const onSubmit = (values) => {
    const { email } = values;

    if (!email) return ShowToast("Please enter your email!", Severty.ERROR);

    setLoading(true);

    request({
      url: apiPath.forgotPassword,
      method: "POST",
      data: { email },
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(
            data.message || "Password reset link sent!",
            Severty.SUCCESS
          );
          navigate("/login");
        } else {
          ShowToast(data.message || "Something went wrong", Severty.ERROR);
        }
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(
          error?.response?.data?.message || "Something went wrong",
          Severty.ERROR
        );
      },
    });
  };

  return (
    <div className="main-new-login-page-designe-divv">
      <Layout className="layout-default layout-signin">
        <Content className="signin">
          <div className="contant-bg-sign">
            <div className="signin-box">
              <div className="signup-logo">
                <img src={signinLogo} alt="Logo" />
              </div>
              <Row justify="space-around">
                <Col xs={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }}>
                  <div className="signup-form">
                    <div className="login_header-mian">
                      <h4>Forgot Your Password?</h4>
                      <h5>Enter your email to reset your password</h5>
                    </div>

                    <Form
                      form={form}
                      onFinish={onSubmit}
                      layout="vertical"
                      className="sign_in_formm"
                    >
                      <Form.Item
                        className="username"
                        label="Email Address"
                        name="email"
                        rules={[
                          {
                            type: "email",
                            message: "Please enter a valid email address!",
                          },
                          {
                            required: true,
                            message: "Please enter your email!",
                          },
                        ]}
                      >
                        <Input placeholder="Enter Email Address" />
                      </Form.Item>

                      <Form.Item>
                        <Button
                          type="primary"
                          htmlType="submit"
                          className="fill-button"
                          loading={loading}
                        >
                          {loading ? "Sending..." : "Submit"}
                        </Button>
                      </Form.Item>
                    </Form>
                      <div
                        className="already_have_account"
                        style={{ textAlign: "center", marginTop: "20px" }}
                      >
                        {" "}
                       Remember your password?{" "}
                        <span
                          style={{
                            color: "#1890ff",
                            cursor: "pointer",
                            fontWeight: "500",
                          }}
                         onClick={() => navigate("/login")}
                        >
                           Back to Login
                        </span>
                      </div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Content>
      </Layout>
    </div>
  );
};

export default ForgotPassword;
